module.exports = {"language":"","screenNumber":1,"oldScreenNumber":1,"playTime":10,"score":0,"israndamized":false,"currentIndex":0,"currentQuestion":{},"showCorrectWrong":false}


//////////////////
// WEBPACK FOOTER
// ./src/gameState.json
// module id = 90
// module chunks = 0